/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import SelectDropDown from '../../common/dropdown/SelectDropdown';
import { TInfo } from '../../types';

import { useGetBusinessSectorQuery } from '../../features/businessRegistration/businessRegistrationSlice';
import { decryptJson } from '../../utils/decryptJson';
import Button from '../../components/global/Button';
import '../../components/BusinessDashboard/BusinessRegistrationWrapper/businessRegistration.css';
import { toast } from 'react-toastify';
import Dropdown from '../../common/dropdown/Dropdown';
import customToast, { ToastType } from '../../components_/Toast';

type TProps = {
  step1: TInfo;
  setStep1: React.Dispatch<React.SetStateAction<TInfo>>;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  step: number;
};
const AboutBusiness = ({ setStep, setStep1, step1, step }: TProps) => {
  const [disable, setDisabled] = useState(false);
  const [description, setDescription] = useState<boolean>();
  const [submitting, setSubmitting] = useState(false);
  const [step1Copy, setStep1Copy] = useState(step1);
  const token = localStorage.getItem('login-token');

  const { data, isLoading, error } = useGetBusinessSectorQuery({ token });

  useEffect(() => {
    if (error) {
      customToast('Could not fetch segments, please refresh your screen', ToastType.error);
    }
  }, [error]);

  const sectors = decryptJson(data?.data);

  const [selectedBusinessSegment, setSelectedBusinessSegment] = useState({
    value: '',
    label: '',
  });
  const completedSteps: boolean[] = JSON.parse(localStorage.getItem('completed-steps') ?? '[]');
  const updateCompletedSteps = () => {
    completedSteps[step - 1] = true;
    localStorage.setItem('completed-steps', JSON.stringify(completedSteps));
  };

  const validateInputsResult = useMemo(() => {
    const isSelectedBusinessSegment = step1Copy?.businessSegment
      ? step1Copy?.businessSegment !== ''
      : false;
    const isBusinessDescription = step1Copy?.businessDesc?.length >= 80;
    setDescription(isBusinessDescription);
    const isNatureOfBusiness = step1Copy?.businessNature ? step1Copy?.businessNature !== '' : false;

    return isSelectedBusinessSegment && isBusinessDescription && isNatureOfBusiness;
  }, [step1Copy?.businessSegment, step1Copy?.businessDesc, step1Copy?.businessNature]);

  // useEffect(() => {
  //   setStep1({
  //     ...step1Copy,
  //     // structureOfBusiness: 'limited liability (1 million share)',
  //   });
  // }, []);

  useEffect(() => {
    if (validateInputsResult) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [validateInputsResult]);

  const displayErrorMsg = (errorText: string, variable: string) => {
    if (submitting && !variable) {
      return <div className='text-[red] text-[11px]'>{errorText}</div>;
    }
  };

  return (
    <div className='stepOneContainer flex w-full sl:w-[700px] '>
      <form className='w-full formCont sl:px-[15px] '>
        <div className='w-full'>
          {/* <div className='font-Poppins font-medium text-[28px] leading-[42px] m-4 !mb-6 !ml-0'>Lets get your business registered!</div> */}

          <div className='sl:flex justify-between'>
            <div className='w-full sl:w-[48%] text-xs mb-[27px] '>
              <Dropdown
                className='border-[1px] border-[#DDDDDD] rounded-[2px] !h-[52px] focus:border-[#F8B400]'
                label='Business Segment'
                labelStyles='text-[#212121] text-sm font-poppins font-normal leading-[18px] pb-[5px] '
                options={
                  data &&
                  sectors?.map((item: any) => {
                    return {
                      label: item.sector,
                      value: item.sector,
                    };
                  })
                }
                width='w-[100%]'
                setSelectedOption={setSelectedBusinessSegment}
                onChange={() => {
                  setStep1Copy({
                    ...step1Copy,
                    businessSegment: selectedBusinessSegment.label,
                  });
                }}
                placeholder={step1Copy?.businessSegment}
                value={step1Copy?.businessSegment}
                isLoading={isLoading}
              />

              {displayErrorMsg('Business segment cannot be empty', step1Copy?.businessSegment)}
            </div>
            <div className='mb-[27px] sl:w-[48%]'>
              <div className='mb-[27px]'>
                <label className='flex flex-col relative text-[#212121] '>Nature of Business</label>
                <input
                  className='w-full h-[52px] px-3 border-[1px] border-[#DDDDDD] rounded-[2px] focus:border-[#F8B400] outline-none '
                  value={step1Copy?.businessNature}
                  placeholder='E.g: branding and marketing'
                  onChange={(e) => {
                    setStep1Copy({ ...step1Copy, businessNature: e.target.value });
                  }}
                />

                {displayErrorMsg('Nature of Business cannot be empty', step1Copy?.businessNature)}
              </div>
            </div>
          </div>
          <div className='mb-[27px] '>
            <label htmlFor='describeBusiness'>Describe your business</label>
            {/* {!description && (
              <span className=' ml-9 text-errorRed font-Poppins  text-[10px]'>
                (must be 80 characters minimum)
              </span>
            )} */}
            <span style={{ color: 'rgba(2, 135, 137, 1)', fontSize: '12px', marginLeft: '20px' }}>
              (Minimum: 80 Characters)
            </span>
            <div className='w-full  rounded-[5px] outline-none border-[1px] border-[#DDDDDD] focus:border-[#f8b400]'>
              <textarea
                id='describeBusiness'
                className='w-full outline-none resize-none text-sm text-[#768396] py-3 px-3 focus:border-[#F8B400]'
                placeholder='Please describe your business in nothing less than 80 words'
                // name='describeBusiness'
                value={step1Copy?.businessDesc}
                onChange={(e) => {
                  setStep1Copy({ ...step1Copy, businessDesc: e.target.value });
                }}
                minLength={80}
              />
            </div>
            {displayErrorMsg('Business description cannot be empty', step1Copy?.businessDesc)}
            {step1Copy?.businessDesc && step1Copy?.businessDesc.length < 80 && (
              <span className='text-errorRed font-Poppins  text-[10px]'>
                (must be 80 characters minimum)
              </span>
            )}
          </div>

          <div className='w-full sl:flex sl:justify-between mt-[40px] sl:items-end'>
            <div className='mb-[27px] sl:w-[48%]'>
              {/* <div className='mb-[27px]'> */}
              <label className='flex flex-col relative text-[#212121] '>
                Organization Structure
              </label>
              <input
                style={{ backgroundColor: 'rgba(221, 221, 221, 1)' }}
                className='w-full  h-[52px] px-2 border-[1px] border-[#B8C9C9] rounded-[2px] focus:border-[#F8B400] outline-none sl:text-[15px] text-xs'
                value={'limited liability (1 million share)'}
                readOnly
              />
              {/* </div> */}
            </div>
            <div className='mb-7 items-center sl:[w-48%] sl:max-w-[177px]'>
              <Button
                // disabled={disable}
                theme='primary'
                className='px-3 py-[10px] text-[11px] inline-block '
                size='sm'
                underline={false}
                onClick={() => {
                  if (!disable) {
                    setStep((currPage) => currPage + 1);
                    updateCompletedSteps();
                    setStep1Copy({
                      ...step1Copy,
                      structureOfBusiness: 'limited liability (1 million share)',
                    });
                    setStep1(step1Copy);
                  }
                  setSubmitting(true);
                }}
                // type='submit'
              >
                SAVE AND CONTINUE
              </Button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default AboutBusiness;
